import { useTranslation } from "react-i18next";
import { IconComponent } from "@/shared/icons/BaseIcon";
import Button from "@/shared/ui/button/Button";

export type VehicleSpawnTabsProps = {
  tabs: {
    id: string;
    icon: IconComponent;
    count: number;
  }[];
  currentTab: string;
  setCurrentTab: (tab: string) => void;
  isLoading: boolean;
};

export function VehicleSpawnTabs({
  tabs,
  currentTab,
  setCurrentTab,
  isLoading,
}: VehicleSpawnTabsProps) {
  const { t } = useTranslation("vehicle");

  return (
    <div className="flex flex-col gap-[6px]">
      {tabs.map((tab) => (
        <Button
          key={tab.id}
          variant={currentTab === tab.id ? "solid-gradient" : "soft"}
          color={currentTab === tab.id ? "accent" : "gray"}
          className="h-[2.75rem] px-3.5 flex justify-between items-center text-white disabled:opacity-30"
          onMouseDown={() => setCurrentTab(tab.id)}
          disabled={isLoading || tab.count === 0}
        >
          <div className="flex items-center gap-2.5">
            <tab.icon className="w-[1.125rem]" />
            {t(`spawn.tabs.${tab.id.toLowerCase()}`)}
          </div>
          {tab.count > 0 && <div className="text-12 font-medium text-gray-400">{tab.count}</div>}
        </Button>
      ))}
    </div>
  );
}
